<ul
  role="tablist"
  class="ds-flex ds-flex-row xs:ds-justify-between sm:ds-justify-start"
>
  <li role="presentation" *ngFor="let tab of tabs">
    <a
      role="tab"
      [name]="tab.name!"
      [active]="tab.active!"
      (click)="onClick($event)"
      (keydown)="onKeydown($event)"
      class="
        ds-px
        ds-py-xs
        ds-block
        ds-border-b-4
        ds-outline-none
        ds-border-transparent
        ds-text-primary-black
        sm:ds-mr-sm
      "
    >
      <ng-template [ngTemplateOutlet]="tab.label.templateRef"></ng-template>
    </a>
  </li>
</ul>
<ng-content select="ui-tabs-header"></ng-content>
<section
  *ngFor="let tab of tabs"
  [name]="tab.name!"
  [active]="tab.active!"
  role="tabpanel"
  class="ds-my ds-outline-none"
>
  <ng-template [ngTemplateOutlet]="tab.panel.templateRef"></ng-template>
</section>
<ng-content select="ui-tabs-footer"></ng-content>
